export enum SearchMode {
	EVERYWHERE = 'EVERYWHERE',
	THIS_FOLDER = 'THIS_FOLDER',
}
